/*
 * Copyright (c) 2020. American Express Company
 */

import { Component, ReactComponentElement } from 'react';

export default class SavingsGoalAd extends Component<any> {
    public override render(): ReactComponentElement<any> {
        return null;
    }
}
